import { constants } from '@trackman/baseball-shared-components';
import { IEditRowPlayer } from '../../interfaces/sessionVerification/plays/IEditRowPlayer';

export const getErrorMessageForEmptyValues = (columnName: string): string | undefined => `No ${columnName}`;

export const isSimpleCellEmpty = (value: string) => {
  if (value === '' || value === null || value === undefined || value === constants.undefinedValue) {
    return true;
  }
  return false;
};

export const isPlayerCellEmpty = (player: IEditRowPlayer) => {
  if (player.name === '' || player.name === null || player.name === undefined) {
    return true;
  }
  return false;
};
